<template>
    <modal :name="modalName" :adaptive="true" :focusTrap="true" :width="480" height="auto" @before-close="handleBeforeClose">
        <div class="p-6 bg-white">
            <h2 class="text-lg font-semibold pb-4 mb-4">Delete envelope</h2>
            <p class="text-sm text-gray-600 mb-6">Are you sure you want to delete this envelope? This cannot be undone.</p>
            <div class="flex justify-end gap-3">
                <button type="button" class="delete-modal-button" @click="close">Cancel</button>
                <button type="button" class="delete-modal-button delete-modal-danger" @click="deleteEnvelope">Delete envelope</button>
            </div>
        </div>
    </modal>
</template>

<script>

export default {

    props: {
        show: {},
        modal_name: { default: 'envelope-delete-modal' },
    },

    computed: {
        modalName() {
            return this.modal_name;
        },
    },

    methods: {
        close(event) {
            this.$modal.hide(this.modalName);
            this.$nextTick(() => {
                this.$emit('closed');
            });
        },
        handleBeforeClose(event) {
            // Only emit closed if the close wasn't triggered by our buttons
            if (! event.stop) {
                this.$emit('closed');
            }
        },
        deleteEnvelope() {
            this.$emit('deleteEnvelope');
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show(this.modalName);
            } else {
                this.$modal.hide(this.modalName);
            }
        },
    },
}
</script>

<style scoped>
.delete-modal-button { border: 1px solid #d1d5db; border-radius: 0.375rem; padding: 0.55rem 0.9rem; font-size: 0.875rem; background: white; color: #374151; }
.delete-modal-button:hover { border-color: #2563eb; color: #2563eb; }
.delete-modal-danger { background: #b91c1c; border-color: #b91c1c; color: white; }
.delete-modal-danger:hover { background: #991b1b; border-color: #991b1b; color: white; }
</style>
